<template>
  <div id="menuShowlogo" @mouseover="onMouseOver" class="yd-logo position-fixed flex-center">
    <img src="@/static/yd-logo-menu.png" class="logo" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { debounce } from 'lodash-es'
  import { getStore } from '@/util/store'
  export default {
    name: 'logo',
    data() {
      this.onMouseOver = debounce(this.onMouseOver, 300, { leading: true, trailing: false })
      return {}
    },
    created() {},
    computed: {
      ...mapGetters(['website', 'keyCollapse'])
    },
    methods: {
      onMouseOver() {
        const flag = getStore({ name: 'firstVisitEditor' })
        if (!flag) {
          return
        }
        this.$store.commit('SET_OPEN', true)
      }
    }
  }
</script>

<style lang="scss">
  .yd-logo {
    cursor: pointer;
    left: 0;
    top: 0;
    height: 56px;
    width: 129px;
    z-index: 998;
    background-color: #22c655;
  }

  .logo {
    height: 56px;
    width: 129px;
  }
</style>
